import { graphql, useStaticQuery } from 'gatsby';

export const useProducts = () => {
  return useStaticQuery(graphql`
    query Product {
      ui3: file(relativePath: { eq: "ui/scorecard.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      essence: file(relativePath: { eq: "ui/essence-new.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      predictors: file(relativePath: { eq: "ui/predictors.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      scorecardbuilder: file(relativePath: { eq: "ui/scorecard-builder.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      report: file(relativePath: { eq: "ui/report-builder.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      chatinsights: file(relativePath: { eq: "ui/chat-insights.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      calldrivers: file(relativePath: { eq: "ui/essence.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      apm: file(relativePath: { eq: "ui/apm.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      qaScore: file(relativePath: { eq: "ui/qaScore.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      agentView: file(relativePath: { eq: "ui/ui-agentView2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      teamView: file(relativePath: { eq: "ui/ui-teamView.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      essenceFlyer: file(relativePath: { eq: "get-to-know-essence.pdf" }) {
        publicURL
      }
      predictorFlyer: file(relativePath: { eq: "get-to-know-predictors.pdf" }) {
        publicURL
      }
      reportFlyer: file(relativePath: { eq: "report-builder-flyer.pdf" }) {
        publicURL
      }
    }
  `)
};
